import React, {
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useState,
    MutableRefObject,
    ReactNode
} from 'react';

interface Modal {
    idRef: MutableRefObject<string>;
    containerRef: MutableRefObject<HTMLDivElement>;
    onCloseRef: MutableRefObject<() => void>;
}

type Modals = Modal[];

const HBModalContext =
    createContext<[Modals, Dispatch<SetStateAction<Modals>>]>(null);

export const HBModalProvider = ({ children }: { children: ReactNode }) => {
    const modalsWarpedContext = useHBModalContext();
    const modals = useState<Modals>([]);

    // We need to go over the code and remove all the places that added this provider, we want all modals to be handled by the same context
    if (modalsWarpedContext) {
        return <>{children}</>;
    }

    return (
        <HBModalContext.Provider value={modals}>
            {children}
        </HBModalContext.Provider>
    );
};

export function useHBModalController() {
    const [, setModals] = useHBModalContext();

    function closeAllModals() {
        setModals(prevModals => {
            prevModals.forEach(modal => {
                modal.onCloseRef.current();
            });
            return [];
        });
    }

    return { closeAllModals };
}
export function useHBModalContext() {
    return useContext(HBModalContext);
}
